import React from 'react'

import {
  useUserAuthorizations,
  LinkAccountConfirmationPage,
  SignInToLinkAccountPage,
} from 'cloud-frontend'
import { IndexLayoutExtraProps } from '@sketch/modules-common'

interface SsoLinkAccountRouteProps extends IndexLayoutExtraProps {}

export const SsoLinkAccountRoute = (props: SsoLinkAccountRouteProps) => {
  const { hasPersonalAuthorization } = useUserAuthorizations()

  if (hasPersonalAuthorization) {
    return <LinkAccountConfirmationPage {...props} />
  } else {
    return <SignInToLinkAccountPage {...props} />
  }
}
